"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePersons = usePersons;
const react_1 = require("react");
const stores_1 = require("../stores/index.js");
const view_models_1 = require("../../view-models/index.js");
function usePersons() {
    const persons = (0, stores_1.useCalculatorStore)((state) => state.data.persons);
    const baseUrl = (0, stores_1.useCalculatorStore)((state) => state.baseUrl);
    return (0, react_1.useMemo)(() => (0, view_models_1.personsViewModel)(persons, baseUrl), [persons, baseUrl]);
}
